export default __webpack_public_path__ + "img/8c38bcf033df00d104df55c068c16bbd.gif";